import React from "react";
import Banner from "../components/HomePageComponents/Banner";
import About from "../components/HomePageComponents/AboutPage";

import Skills from "../components/HomePageComponents/Skills";
import Services from "../components/HomePageComponents/Services";
import Projects from "../components/HomePageComponents/Projects";

import { Link } from "react-router-dom";
import { useGetProjectsQuery } from "../features/projects/projectsApi";
import Project from '../Projects/'
import Contact from "../Contact";
import SlidingImages from '../SlidingImages'
import Rounded from "../Projects/Test/common/RoundedButton";
import Seo from "../seo";
import { ArrowRight } from "lucide-react";

const HomePage = () => {
  
    const { data: projects, isLoading, isError, error } = useGetProjectsQuery();


    return (
        <div>

<Seo
        title="Md Shakil Hossain - Portfolio | devshakilh"
        description="Welcome to Md Shakil Hossain's portfolio. Discover my projects, skills, and contact information. devshakilh"
        keywords={['Md Shakil Hossain', 'portfolio', 'developer','devshakilh', 'bd', 'FullStack Developer', 'fullstack developer | developer', 'frontend engineer', 'mernstack developer']}
        author="Md Shakil Hossain"
        url="https://shakilhossain.vercel.app/"
        image="https://shakilhossain.vercel.app/devshakilh-logo.png"
        twitterHandle="devshakilh"
      />

            <div class="relative h-full w-full bg-slate-950"><div class="absolute bottom-0 left-[-20%] right-0 top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div><div class="absolute bottom-0 right-[-20%] top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div></div>
          <div  className="lg:x-12">
          <Banner />


<About />

<Skills />
{/* <PricingTable/> */}
<div class="relative h-full w-full bg-slate-950"><div class="absolute bottom-0 left-[-20%] right-0 top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div><div class="absolute bottom-0 right-[-20%] top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div></div>
<Services />
<div class="relative h-full w-full bg-slate-950"><div class="absolute bottom-0 left-[-20%] right-0 top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div><div class="absolute bottom-0 right-[-20%] top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div></div>
<Projects
    projects={projects}
    isLoading={isLoading}
    isError={isError}
    error={error}
    slice={3}
   
/>
<div className="mt-10 mb-72">
    <button className="=  h-10 wfull  ov">
        <Link to="/projects">
           

<div className="">
<Rounded >
  <p className="text-xl  cursor-pointer flex font-bold gap-2">see all project <span className='font-extrabold mt-[6px]' style={{ transform: 'rotate(-45deg)' }}>
  <ArrowRight />
</span>
</p>
</Rounded>
</div>

        </Link>
    </button>
</div>
<Project/>
          </div>
          <div class="relative h-full w-full bg-slate-950"><div class="absolute bottom-0 left-[-20%] right-0 top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div><div class="absolute bottom-0 right-[-20%] top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div></div>
          <h3 className="  flex justify-center text-4xl pb-12 text-highlight mt-[160px] bg-white pt-12">
                <div className='flex  gap-3 items-center  border-[2px] w-[189px] text-black border-black py-1 px-5 hover:bg-black hover:text-white rounded-3xl'>Gallery <span className="hover:rotate-180 "> <img className="w-6 h-6 mt-" alt="imag" loading="lazy" src="https://i.ibb.co/G3xK0m8/im.png"/></span></div>

                    
                </h3>
            <SlidingImages/>
            <div class="relative h-full w-full bg-slate-950"><div class="absolute bottom-0 left-[-20%] right-0 top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div><div class="absolute bottom-0 right-[-20%] top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]"></div></div>
          <Contact/>
           
        </div>
    );
};

export default HomePage;
